import { string } from 'mathjs'
import { TimeStamps } from './common'
import { MappedIn } from './mappedIn'

export type VoiceBackend = 'zello' | 'fleet'

export interface Address {
  city: string
  state: string
  street1: string
  street2: string
  zipcode: string
}

interface Firmware {
  [key: string]: string
}

interface OrgProps {
  address: Address
  image: string
  legacy?: any
  logoUrl: string
  phone: string
  proximityUuid: {
    name: string
    value: string
  } | null
  firmware?: Firmware
}

interface OrgSummary {
  alertSources: {
    critical: number
    disabled: number
    healthy: number
    high_battery: number
    late: number
    low_battery: number
    med_battery: number
    need_update: number
    total: number
  }
  alerts: {
    critical: number
    moderate: number
    resolved: number
    responseTime: number
    lastTest: number
  }
  beacons: {
    critical: number
    disabled: number
    healthy: number
    high_battery: number
    late: number
    low_battery: number
    med_battery: number
    need_update: number
    total: number
  }
  responders: {
    critical: number
    late: number
    pushDisabled: number
    pushEnabled: number
    total: number
  },
  gateways: {
    critical: number
    moderate: number
    healthy: number
    late: number
    total: number
  }
}

export enum OrgType {
  Group = 'group',
  Property = 'property',
}

export interface Organization extends TimeStamps {
  id: string
  name: string
  lat?: number
  long?: number
  geofencingEnabled?: boolean
  responderRadiusInMiles?: number
  tzOffset?: number
  orgType: OrgType
  parents?: string[]
  props: OrgProps
  responseTime?: number
  summary?: OrgSummary
  testInterval?: number
  subscriptionTier?: "essential" | "elite" | "ultimate" 
  subscriptionStatus?: "paid" | "delinquent" | "suspended"
  mappedin?: MappedIn | null
  zelloApiKey?: string
  zelloPassword?: string
  zelloSubdomain?: string
  zelloUsername?: string
  zelloUserMax?: number
  // Read-only: set once by enable_voice, never by an org update.
  voiceBackend?: VoiceBackend
  zelloProvisioningStatus?: string | null
}

// export interface OrganizationResponse {
//   data?: Organization
//   included?: IdTypePair[]
//   links?: Links
// }

// export interface OrganizationListResponse {
//   data?: Organization[]
//   links?: Links
//   meta?: Meta
// }

export type ChildOrg = {
  childOrgId: string
  parentOrgId: string
} & TimeStamps
